import {
  isApplicantAccount,
  isOrganizationMemberAccount
} from '~/utils/userAccountType';

/**
 * Middleware to prevent users from accessing pages not meant for their user type
 * Prevents 500 errors by showing error pages without triggering additional API calls
 */
export default async function ({ app, store, redirect, route, error }) {
  // Ensure user data is loaded before checking organization membership
  if (!store.getters['user/user']) {
    await store.dispatch('user/getUser');
  }
  
  // Get user information from store
  const user = store.getters['user/user'] || {};
  const isApplicant = isApplicantAccount(user);
  const isOrganization = isOrganizationMemberAccount(user) && !!user.current_organization;
  
  // Define route groups for different user types
  const organizationOnlyRoutes = [
    '/job-offer/create',
    '/job-offer/edit',
    '/organization',
    '/billing'
  ];
  
  const applicantOnlyRoutes = [
    '/talent-pool',
    '/browse'
  ];

  // Special handling for applicant profile routes
  const applicantProfileRegex = /^\/applicant-profile\/([^\/]+)/;
  const isApplicantProfileRoute = applicantProfileRegex.test(route.path);
  
  // Check if current route path starts with any of the restricted paths
  const isOrganizationRoute = organizationOnlyRoutes.some(path => 
    route.path.startsWith(path)
  );
  
  const isApplicantRoute = applicantOnlyRoutes.some(path => 
    route.path.startsWith(path)
  );
  
  // Error handling logic based on user type and current route
  if (isOrganizationRoute && !isOrganization) {
    console.warn('Organization access denied: User is not part of an organization');
    return error({ statusCode: 403, message: 'Access denied: This page is only available to organization users' });
  }
  
  // Special handling for applicant profile routes
  if (isApplicantProfileRoute && !isApplicant) {
    console.warn('Applicant profile access denied: User is not an applicant');
    return error({ statusCode: 403, message: app?.i18n?.t('error.candidate-profile-access') || 'Access denied: Organization users cannot access candidate profiles' });
  }
  
  if (isApplicantRoute && !isApplicant) {
    console.warn('Applicant access denied: User is not an applicant');
    return error({ statusCode: 403, message: app?.i18n?.t('error.candidate-only') || 'Access denied: This page is only available to candidates' });
  }
  
  // Allow access to the requested page
  return true;
}
